import script from "./TdsVdsListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TdsVdsListTable.vue?vue&type=script&setup=true&lang=js"

import "./TdsVdsListTable.vue?vue&type=style&index=0&id=536c3efc&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-536c3efc"]])

export default __exports__